<template>
  <section class="network-section" :style="{ backgroundImage: activityData.images.bg ? `url(${activityData.images.bg})` : 'none' }">
    <Header :notificationIconClass="notificationIconClass" :playProfileNotification="playProfileNotification" />
    <div class="network-container">
      <Banner v-if="$store.state.template.banners.enableBanners" :bannerSlot="'network_top_banner'" />
      <div class="foyerCategory-title" v-html="activityData.property.sectionTitle" v-if="activityData.property.sectionTitle"></div>
      <div class="card-search-container">
        <input class="network-searchbox-input" type="text" v-model="search" placeholder="Digite usuário ou empresa" @keydown.enter="searchAPI" />
        <i class="fa fa-times-circle network-clearSearchIcon" @click.prevent="getCards"></i>
        <img class="network-searchIcon" src="@/assets/img/search.svg" @click.prevent="searchAPI" />
      </div>
      <div class="cards-container">
        <Card
          v-for="(card, i) in filteredCards"
          :key="i"
          :card="card"
          :style="{ width: '200px', height: 'auto' }"
          :imageStyle="{ width: '200px', height: '200px' }"
          :cardDetailsStyle="{ justifyContent: 'stretch' }"
          :roleStyle="{ flexGrow: '1' }"
          :descriptionStyle="{ display: 'none' }"
          @showCalendar="showCalendar"
          @addContact="playAddContactAnimation" />
      </div>
    </div>
    <div v-if="showSpinner" style="position: fixed; background: #20202060; width: 100vw; height: 100dvh; top: 0; left: 0">
      <div class="lds-spinner" style="padding-top: 10%">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div style="position: fixed; top: 100px; right: 0; bottom: 0; left: 0; z-index: 100" v-if="userId">
      <div style="cursor: pointer; background: #40404080; position: absolute; top: -1px; right: 0; bottom: 0; left: 0" @click="userId = ''"></div>
      <UserSchedule :user_id="userId" style="position: absolute; top: 0; right: 0; bottom: 0; left: 5%; z-index: 0" />
    </div>
    <Footer />
  </section>
</template>

<script>
import Header from '@/components/general/Header.vue';
import Card from '@/components/general/Card.vue';
import api from '@/services/api.js';
import DefaultAvatar from '@/assets/img/default_avatar.png';
import Banner from '@/components/banners/Banner.vue';
import UserSchedule from '@/components/general/UserSchedule.vue';
import Footer from '@/components/general/Footer.vue';

export default {
  name: 'Network',
  components: { Header, Card, UserSchedule, Banner, Footer },

  data() {
    return {
      userId: '',
      accessConfig: {},
      search: '',
      page: [],
      itensPerPage: 20,
      paginationCount: 0,
      cards: [],
      activityData: { images: {}, property: {}, interactivities: [] },
      roleTags: [],
      showSpinner: false,
      searchAPITerm: '',
      searchFields: { code: true, name: true, email: true, cpf: true, telephone: true, other: true },
      headerFields: ['id', 'Nome', 'Email', 'CPF', 'Telefone', 'Code', 'Other'],
      notificationIconClass: 'fa-user-check',
      playProfileNotification: false,
    };
  },
  computed: {
    filteredCards() {
      return this.cards.filter((card) => {
        try {
          if (!card.company) card.company = '';
          const matched = card.name.toLowerCase().match(this.search.toLowerCase()) || card.role.toLowerCase().match(this.search.toLowerCase()) || card.company.toLowerCase().match(this.search.toLowerCase());
          card.name = card.name.toLowerCase();
          return true;
        } catch (err) {
          console.error(err);
          return false;
        }
      });
    },
  },
  watch: {
    $route() {
      this.loadActivity();
    },
  },
  methods: {
    loadActivity() {
      api.get(`activity/${this.$route.params.stream}`).then((response) => {
        // console.log(response);
        let tempImages = { ...this.activityData.images };
        this.activityData = { ...this.activityData, ...response.data };
        this.activityData.images = response.data.images ? JSON.parse(response.data.images) : tempImages;

        let tempProperty = { ...this.activityData.property };
        this.activityData.property = response.data.property ? JSON.parse(response.data.property) : tempProperty;
        this.getCards();
      });
    },
    getCards() {
      try {
        this.search = '';
        this.paginationCount = 0;
        this.cards = [];
        this.showSpinner = true;
        api
          .get(`event/${this.$store.state.eventId}/userSearch?limit=${this.itensPerPage}&page=${this.paginationCount}`)
          .then((response) => {
            // console.log('Users= ', { response });
            this.showSpinner = false;

            if (response.data) {
              response.data.userExists.map((item) => {
                // console.log(JSON.stringify(item));
                this.cards.push(this.cardPayloadBuilder(item));
              });
            }
          })
          .catch((err) => console.error(err));
      } catch (error) {
        console.error(error);
      }
    },
    getCardsOnScroll() {
      // console.log('getCardsOnScrollTop', { document }, 'scrollTop: ', document.documentElement.scrollTop + document.documentElement.offsetHeight, 'offsetHeight: ', document.documentElement.offsetHeight, 'scrollHeight', document.documentElement.scrollHeight);
      if (document.documentElement.scrollTop === 0) {
        // console.log('TOP');
      }
      if (document.documentElement.scrollTop + document.documentElement.offsetHeight >= document.documentElement.scrollHeight) {
        // console.log('BOTTOM');
        try {
          this.paginationCount++;
          api
            .get(`event/${this.$store.state.eventId}/userSearch?limit=${this.itensPerPage}&page=${this.paginationCount * this.itensPerPage}${this.userSearchQuery()}`)
            .then((response) => {
              // console.log('Users onScroll ', response.data);
              if (response.data) {
                response.data.userExists.map((item) => {
                  // console.log(JSON.stringify(item));
                  this.cards.push(this.cardPayloadBuilder(item));
                });
              }
            })
            .catch((err) => console.error(err));
        } catch (error) {
          console.error(error);
        }
      }
    },
    cardPayloadBuilder(item) {
      return {
        image: item.image ? item.image : DefaultAvatar,
        name: item.name ? item.name : item.email,
        role: `${item.role ?? ''} ${item.role && item.company ? ' - ' : ''} ${item.company ?? ''} ${(item.role || item.company) && item.city ? ' - ' : ''} ${item.city ? item.city : ''} ${item.state ? ' - ' + item.state : ''} ${
          item.about_me ? ' - ' + item.about_me : ''
        }`,
        action: 'MENSAGEM',
        actionType: 'talk',
        enableAction: true,
        url: item.user_id > this.$store.state.user.id ? item.user_id + this.$store.state.user.id : this.$store.state.user.id + item.user_id,
        target: item.user_id,
        enableAction: item.user_id != this.$store.state.user.id,
        public_events: item.public_events ? parseInt(item.public_events) : 0,
        contact_added: item.contact_added,
      };
    },
    userSearchQuery() {
      this.searchAPITerm = this.search;
      // let mainURL = `/userSearch?field[]=code&field[]=name&value=SP&limit=500&page=0&order_by=name&asc_desc=asc`;
      let orderingField = `&asc_desc=asc`;
      let nameField = `&field[]=name`;
      let companyField = `&field[]=company`;
      let cityField = `&field[]=city`;
      let stateField = `&field[]=state`;
      let valueField = this.searchAPITerm ? `&value=${this.searchAPITerm}` : '';
      return `${nameField}${companyField}${orderingField}${valueField}`;
    },
    searchAPI() {
      this.showSpinner = true;
      api
        .get(`event/${this.$store.state.eventId}/userSearch?limit=${this.itensPerPage}&page=0${this.userSearchQuery()}`)
        .then((response) => {
          this.showSpinner = false;
          // console.log('searchAPI', { response });
          if (response.data) {
            this.paginationCount = 0;
            this.cards = [];
            response.data.userExists.map((item) => {
              // console.log(JSON.stringify(item));
              this.cards.push({
                image: item.image ? item.image : DefaultAvatar,
                name: item.name ? item.name : item.email,
                role: `${item.role ?? ''} ${item.role && item.company ? ' - ' : ''} ${item.company ?? ''} ${(item.role || item.company) && item.city ? ' - ' : ''} ${item.city ? item.city : ''} ${item.state ? ' - ' + item.state : ''} ${
                  item.about_me ? ' - ' + item.about_me : ''
                }`,
                action: 'MENSAGEM',
                actionType: 'talk',
                enableAction: true,
                url: item.user_id > this.$store.state.user.id ? item.user_id + this.$store.state.user.id : this.$store.state.user.id + item.user_id,
                target: item.user_id,
                enableAction: item.user_id != this.$store.state.user.id,
                public_events: item.public_events ? parseInt(item.public_events) : 0,
              });
            });
          }
        })
        .catch((err) => console.error(err));
    },
    showCalendar(userId) {
      this.userId = userId;
    },
    playAddContactAnimation() {
      this.playProfileNotification = true;
      setTimeout(() => {
        this.playProfileNotification = false;
      }, 1000);
    },
  },
  beforeMount() {
    this.accessConfig = this.$store.state.template.accessConfig;
    this.loadActivity();
  },
  mounted() {
    document.addEventListener('scroll', this.getCardsOnScroll);
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.getCardsOnScroll);
  },
};
</script>

<style scoped lang="scss">
.network-section {
  position: relative;
  background-position: center;
  background-size: cover;
  background-attachment: fixed;
  background-repeat: repeat-y;
  width: 100vw;
}
.network-container {
  // background: linear-gradient(180deg, $button-background 0%, $main-color 50%);
  // height: 100dvh;
  padding-top: 100px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 97vh;
  @include media('<=phone') {
    padding-top: 50px;
  }
}
.network-title {
  position: relative;
  align-self: center;
  margin-top: 2%;
  width: auto;
  font-size: 40px;
  font-weight: bolder;
  color: var(--text-color);

  // border-bottom: 1px solid white;
  h1 {
    font-size: 32px;
    letter-spacing: 2px;
    text-align: center;
    margin-bottom: 0;
  }
}
.card-search-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 500px;
  height: 40px;
  margin-top: 1.5%;
  margin-bottom: 1.5%;
  background-color: white;
  border-radius: var(--input-borderRadius);
  border: 0;
  outline: none;
  input {
    width: 86%;
    height: 100%;
    text-align: left;
    background-color: white;
    border-radius: var(--input-borderRadius);
    border: 0;
    outline: none;
    margin-left: 3%;
  }
  .network-clearSearchIcon {
    font-size: 0.9rem;
    margin-right: 8px;
    color: #999;
    z-index: 0;
  }
  .network-searchIcon {
    cursor: pointer;
    margin: auto;
    background: #ddd;
    height: 100%;
    margin-left: auto;
    padding: 4px;
    border-top-right-radius: var(--input-borderRadius);
    border-bottom-right-radius: var(--input-borderRadius);
  }
}
.search-button {
  background-color: var(--button-background);
  height: 30px;
  width: 100px;
  color: white;
  border: 0;
  outline: none;
  margin-bottom: 1%;
  cursor: pointer;
}
.search-button:hover {
  background-color: var(--secondary-color);
}
.cards-container {
  position: relative;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: stretch;
  align-items: stretch;
  justify-content: flex-start;
  padding: 0 0 100px 6%;
}
.card-container {
  // width: 42%;
  margin: 1%;
  // max-height: 420px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.pagination-container {
  display: flex;
  justify-content: center;
  margin-top: 1%;
}
.pagination {
  user-select: none;
}
// BREAKPOINT
@include media('<=1242px') {
  // .network-section {
  //   background-size: contain;
  // }
}
@include media('<=850px') {
  .card-search-container {
    width: 76vw;
    margin-top: 3%;
    margin-bottom: 5%;
  }
  .search-button {
    margin-bottom: 5%;
  }
  .cards-container {
    justify-content: center;
    padding: 0;
  }
  .card-container {
    margin-bottom: 30px;
  }
}
</style>
